module.exports = __webpack_public_path__ + "images/cloud_uploade7a9a01c02db287deb61c4aebb215e37.svg";